import type { JSX } from "react";

import { DownOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import { PendoProps } from "../../utils/pendo";
import { Button, ButtonProps } from "../Button";

import * as theme from "./CollapseExpandButton.css";

interface CollapseExpandButtonProps extends PendoProps {
    onClick: () => void;
    collapsed: boolean;
}

export function CollapseExpandButton({
    onClick,
    collapsed,
    "data-pendo": dataPendo,
}: CollapseExpandButtonProps): JSX.Element {
    const iconClassNames = cx(
        theme.collapseExpandIcon,
        !collapsed && theme.collapseExpandIconExpanded
    );
    return (
        <Button
            data-pendo={dataPendo}
            variant="text"
            className={theme.collapseExpandButton}
            onClick={onClick}
        >
            <DownOutlined className={iconClassNames} />
        </Button>
    );
}

interface CollapseExpandTextButtonProps {
    onClick: () => void;
    collapsed: boolean;
    type?: ButtonProps["variant"];
    expandLabel: string;
    collapseLabel: string;
}

export function CollapseExpandTextButton({
    onClick,
    collapsed,
    type = "link",
    expandLabel,
    collapseLabel,
}: CollapseExpandTextButtonProps): JSX.Element {
    const iconClassNames = cx(
        theme.collapseExpandIcon,
        !collapsed && theme.collapseExpandIconExpanded
    );
    const icon = <DownOutlined className={iconClassNames} />;
    const label = collapsed ? expandLabel : collapseLabel;

    return (
        <Button
            className={theme.collapseExpandTextButton}
            icon={icon}
            variant={type}
            onClick={onClick}
        >
            {label}
        </Button>
    );
}
